import mediaFormats from '../constants/mediaFormats';
export default function getMediaFormat(playlistType, mediaType) {
    return playlistType?.toLowerCase() === mediaFormats.pls
        ? mediaFormats.pls
        : mediaType?.toLowerCase() || undefined;
}
